<script>
  export let item;

  let bild1Online = "//www.institutional-money.com/content/kgv/bilder/" + item.referent1image;
</script>

<div class="flex gap-4">
  <div class="flex flex-1 flex-col">
    <h1 class="mb-2 font-medium text-theme-signal">{item.eventTitle}</h1>
    <h2 class="order-first font-medium">{item.referent1name}</h2>
    <p>{item.eventDescription}</p>
    <table class="mt-4 w-fit">
      <tbody>
        <tr>
          <th class="pr-4 text-left">Vortrag</th>
          <td>{item.startDate}</td>
        </tr>
        <tr>
          <th class="pr-4 text-left">{item.location}</th>
          <td>{item.startTime} - {item.endTime}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <figure class="basis-[120px]">
    <img width="120" height="180" class="w-full" title={item.referent1name} alt={item.referent1name} src={bild1Online} />
  </figure>
</div>
<div class="prose mt-12 max-w-none [&>p:first-child>strong]:font-normal [&>p:first-child]:text-lg">
  {@html item.referent1resume}
  {@html item.eventDescription3}
</div>
